/* ── Admin Video Previewer (ES Module) ── */
import { catalog, selectedChannel } from './admin-globals.js';
import { openSingleVideoPreview, closeWatchModal as closePreview } from './watch-modal.js';

let _previewAddFn = null;

/**
 * Previsualiza un archivo directamente desde el explorador Minio
 */
export function previewMinioFile(file) {
  openSingleVideoPreview(file);
  
  // Mostrar botón añadir específico de la tele
  const addBtn = document.getElementById('watch-add-btn');
  if (addBtn) addBtn.classList.remove('hidden');

  // Configurar botón añadir
  _previewAddFn = () => { 
    closePreview(); 
    if (window.addMinioFile) window.addMinioFile(file); 
  };
}

/**
 * Previsualiza un vídeo que ya está en el catálogo
 */
export function previewVideo(index) {
  const vid = catalog[selectedChannel].videos[index];
  openSingleVideoPreview(vid);
}

/**
 * Cierra la previsualización y libera recursos
 */
export { closePreview };

// Exponer el callback de añadir para el botón del modal
window._previewAddFnCall = () => { if(_previewAddFn) _previewAddFn(); };
